import { useApiGet } from '../../../shared/api/utils/reactQueryProvider';
import { getRiderAssistantOnRide } from '../../api/services/Rides';
import { IRiderAssistantDetails } from '../../types/riderAssistant';

interface IUseRiderAssistantDetailsQuery {
  rideSlug: string;
}

export const useRiderAssistantOnRideQuery = ({ rideSlug }: IUseRiderAssistantDetailsQuery) => {
  return useApiGet<{ data: IRiderAssistantDetails }>(
    ['riderAssistantDetails'],
    () => getRiderAssistantOnRide(rideSlug),
    {
      enabled: true,
    }
  );
};
